import { useEffect, useState } from "react";
import "../styles/Dashboard.css";

const Dashboard = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserData = async () => {
      const authToken = localStorage.getItem("authToken");

      if (!authToken) {
        console.error("Token de autenticação não encontrado no localStorage.");
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(
          "https://x8ki-letl-twmt.n7.xano.io/api:g_BmLeE8/auth/me",
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Erro ao buscar dados do usuário.");
        }

        const data = await response.json();
        setUserData(data);
        localStorage.setItem("userData", JSON.stringify(data));
      } catch (error) {
        console.error("Erro ao buscar dados do usuário:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
      </div>
    );
  }

  if (!userData) {
    return <p>Erro ao carregar os dados do usuário.</p>;
  }

  const trintaPorCento = userData.valor_total_consultas * 0.3;
  const valorFormatado = `R$ ${trintaPorCento.toFixed(2).replace(".", ",")}`;

  return (
    <div className="dashboard-container">
      <div className="welcome-div">
        <h1>Bem-vindo, {userData.name}</h1>
        <h3>Que nenhuma pessoa morra por falta de saúde!</h3>
      </div>
      <div className="info-div">
        <p><strong>Email:</strong> {userData.email}</p>
        <p><strong>Total de Pacientes:</strong> {userData.qtd_pacientes}</p>
        <p><strong>Total de Consultas:</strong> {userData.qtd_total_consultas}</p>
        <p><strong>Valor Total das Consultas:</strong> 
          {userData.valor_total_consultas 
            ? ` R$ ${userData.valor_total_consultas.toFixed(2).replace(".", ",")}` 
            : " Informação não disponível"}
        </p>
        <p><strong>Valor Total Distribuído em Cashback:</strong> {valorFormatado}</p>
        <p><strong>Seu token de indicação:</strong> {userData.tokenindica}</p>
        <p>
          <strong>Seu link de indicação:</strong> <br />
          <a href={`https://app.cronusaude.com.br/register?code=${userData.tokenindica}`} 
            id="linkIndicacao">
            https://app.cronusaude.com.br/register?code={userData.tokenindica}
          </a>
        </p>
      </div>
    </div>
  );
};

export default Dashboard;
